<rating [rating]=rating></rating><span *ngIf='reviewCount!=null' style='color: #888888'><small>({{reviewCount}})</small></span>